import React from "react";
import {
  Box,
  Skeleton,
  useMediaQuery,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import Typewriter from "typewriter-effect";
import { ReactComponent as Shape } from "../resources/icons/Shape_blue-donute-u.svg";
import { ReactComponent as DownloadOn } from "../resources/icons/download-on.svg";
import Navbar from "./Navbar";
import { fCurrency } from "../common/utils/CommonFunctions";
import { Link } from "react-router-dom";
import MapImage from "../resources/images/StaticPageImg/static-map-image.png";

const HeroSection = ({ totalGems }) => {
  const theme = useTheme();
  const isDownToSM = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        height: "80vh",
        minHeight: "700px",
        overflow: "scroll",
        padding: 2.5,
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: "100%",
          borderRadius: 5,
          overflow: "hidden",
          backgroundColor: "#ece7e4",
        }}
      >
        <Box
          sx={{
            backgroundImage: `url(${MapImage})`,
            height: "100%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            borderRadius: "inherit",
          }}
        />
        <Navbar />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            position: "absolute",
            top: 100,
            right: {xs: 16, sm: 40},
            zIndex: 10,
          }}
        >
          <Stack direction={"row"}>
            <Box
              sx={{
                backgroundColor: "#fff",
                position: "relative",
                pl: "50px",
                pr: "13px",
                py: "5px",
                borderRadius: "20px",
              }}
            >
              <Shape
                style={{
                  position: "absolute",
                  left: -10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "46px",
                  height: "46px",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 800,
                  color: "#000",
                  display: "inline-flex",
                  alignItems: "center",
                  fontFamily: "Grandstander, sans-serif !important",                 
                }}
              >
                DISTRIBUTED AMOUNT &nbsp;
                <Typography
                  component={"span"}
                  variant="body1"
                  sx={{
                    fontWeight: 800,
                    color: theme.palette.primary.main,
                    fontFamily: "Grandstander, sans-serif !important",
                  }}
                >
                  {totalGems ? (
                    fCurrency(totalGems)
                  ) : (
                    <Skeleton variant="rectangular" width={100} height={16} />
                  )}
                </Typography>
              </Typography>
            </Box>
          </Stack>
        </Box>
        <Box
          sx={{
            maxWidth: { xs: "883px", xl: "1200px" },
            flex: 1,
            pt: { sm: "131px" },
            pb: { xs: "100px", sm: "202px" },
            alignContent: "end",
            px: { xs: 2, sm: 3, md: 5 },
            position: "absolute",
            top: 150,
            zIndex: 10,
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "34px", sm: "48px", xl: "58px" },
              fontWeight: 700,
              color: theme.palette.primary.main,
              letterSpacing: "-3px",
              textTransform: "capitalize",
              minHeight: {
                xs: "205px",
                sm: "205px",
                md: "145px",
                lg: "135px",
                xl: "175px",
              },
              fontFamily: "Grandstander, sans-serif !important",
            }}
          >
            <Typewriter
              options={{
                strings: [
                  "CONNECT WORLDS WITH EVERY TAP MAKE EVERY JOURNEY REWARDING",
                  "BRING THE THRILL OF DISCOVERY TO YOUR FINGERTIPS",
                  "WE TURN EVERY LOCATION INTO AN ADVENTURE",
                ],
                autoStart: true,
                loop: true,
                delay: 50,
                pauseFor: 2500,
              }}
            />
          </Typography>
          <Link
            target="_blank"
            to={"https://apps.apple.com/in/app/figrun/id6504271752"}
          >
            <DownloadOn
              width={isDownToSM ? "150px" : "215.02px"}
              style={{ marginTop: isDownToSM ? "10px" : "18px" }}
            />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
